import { render } from "./ServerDetails.vue?vue&type=template&id=dd6b8070&scoped=true&ts=true"
import script from "./ServerDetails.vue?vue&type=script&lang=ts"
export * from "./ServerDetails.vue?vue&type=script&lang=ts"

import "./ServerDetails.vue?vue&type=style&index=0&id=dd6b8070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6b8070"]])

export default __exports__